import { CHECKBOX_STATUS } from 'ui/checkbox';
import { BasicMenuItem } from './BasicMenuItem';
import { CheckboxMenuItem } from './CheckboxMenuItem';
import { InputMenuItem } from './InputMenuItem';
import { NestedMenuItem } from './NestedMenuItem';
import { DividerMenuItem, ExpandableMenuItem } from './Styled';
import { TitleMenuItem } from './TitleMenuItem';
import { MenuItemProps } from './types';

export const MenuItem = ({
  children,
  content,
  hasCountBadge = false,
  id,
  isCheckable = false,
  isDivider = false,
  isExpandableGroup = false,
  isInput = false,
  isSelected = false,
  isTitle = false,
  label,
  onSelectionChange,
  onStringQueryChange,
  options,
  primaryButtonText,
  secondaryButtonText,
  selectedOptionIds = [],
  ...otherProps
}: MenuItemProps) => {
  if (isTitle) {
    return <TitleMenuItem id={id} label={label} content={content} />;
  } else if (options) {
    if (isExpandableGroup && onSelectionChange)
      return (
        <ExpandableMenuItem
          data-test="expandable-menu-item"
          count={null}
          isCollapsible={false}
          isSelected={
            selectedOptionIds.length > 0 && selectedOptionIds.length < options.length
              ? CHECKBOX_STATUS.INDETERMINATE
              : isSelected
          }
          label={label}
          onClick={() => onSelectionChange(id)}
        >
          {options.map((option) => (
            <CheckboxMenuItem
              key={option.id}
              id={option.id}
              label={option.label}
              onSelectionChange={() => onSelectionChange(option.id)}
              isSelected={selectedOptionIds.includes(option.id)}
            />
          ))}
        </ExpandableMenuItem>
      );

    return (
      <NestedMenuItem
        id={id}
        options={options}
        label={label}
        content={content}
        hasCountBadge={hasCountBadge}
        selectedOptionIds={selectedOptionIds}
        onSelectionChange={onSelectionChange}
        onStringQueryChange={onStringQueryChange}
        {...otherProps}
      />
    );
  } else if (isDivider) {
    return <DividerMenuItem />;
  } else if (isInput) {
    return (
      <InputMenuItem
        id={id}
        onStringQueryChange={onStringQueryChange}
        primaryButtonText={primaryButtonText || label}
        secondaryButtonText={secondaryButtonText}
        {...otherProps}
      />
    );
  } else if (isCheckable) {
    return (
      <CheckboxMenuItem
        id={id}
        label={label}
        content={content}
        onSelectionChange={onSelectionChange}
        isSelected={isSelected}
        {...otherProps}
      >
        {children}
      </CheckboxMenuItem>
    );
  }
  return (
    <BasicMenuItem
      id={id}
      label={label}
      content={content}
      onSelectionChange={onSelectionChange}
      isSelected={isSelected}
      {...otherProps}
    >
      {children}
    </BasicMenuItem>
  );
};
